import "../components/About/about.css"
import Header from "../components/About/Header";
import JoinForces from "../components/About/JoinForces";
import Locations from "../components/About/Locations";
import OurTeam from "../components/About/OurTeam";
import TeamBusiness from "../components/About/TeamBusiness";
import HowWeWork from "../components/About/HowWeWork";

import TransitionPage from '../utils/TransitionPage';
import { Helmet } from 'react-helmet-async';

const About = () => {
    return (
      <>
        <Helmet>
          <title>About Advante Digital | AI-Assisted Software Delivery</title>
          <meta name="description" content="Advante Digital helps companies maintain, modernize, and improve existing software platforms using AI-assisted engineering, human review, staging, QA, pull requests, and controlled deployment powered by Motionode."/>
          <meta name="keywords" content="software delivery, software maintenance, software modernization, AI-assisted engineering, human review, QA, staging, pull requests, controlled deployment, Motionode"/>
        </Helmet>
          <Header />
          <OurTeam />
          <TeamBusiness />
          <HowWeWork />
          <Locations />
          <JoinForces />
      </>
    );
  }
  
  export default TransitionPage( About );